/*
 * ご飯のお供ページ：GTM（dataLayer）に送る合図
 * ・otomo_group_view   … 商品一覧の各グループ（野沢菜など）が画面に入ったとき（グループごとに1回）
 * ・otomo_product_click … 商品画像・商品名を押して商品ページへ移動するとき
 * ・otomo_add_to_cart  … カートに入れるのに成功したとき（失敗したときは送らない）
 * GTM側で、この event 名をきっかけにGA4へ送る。
 */
(function () {
  if (window.cOtomoTrack) return;

  window.dataLayer = window.dataLayer || [];

  function groupName(el) {
    var group = el.closest('[data-c-otomo-group]');
    return group ? group.getAttribute('data-c-otomo-group') : '';
  }

  function itemData(item) {
    return {
      item_name: item.getAttribute('data-product-name') || '',
      item_id: item.getAttribute('data-product-id') || '',
      variant_id: item.getAttribute('data-variant-id') || '',
      price: Number(item.getAttribute('data-price')) || 0,
    };
  }

  function push(eventName, params) {
    var data = { event: eventName };
    for (var key in params) data[key] = params[key];
    window.dataLayer.push(data);
  }

  window.cOtomoTrack = {
    addToCart: function (item, quantity) {
      if (!item) return;
      var d = itemData(item);
      push('otomo_add_to_cart', {
        otomo_group: groupName(item),
        item_name: d.item_name,
        item_id: d.item_id,
        variant_id: d.variant_id,
        price: d.price,
        quantity: quantity,
        value: d.price * quantity,
        currency: 'JPY',
      });
    },
  };

  // 商品一覧の各グループが画面に入ったとき（グループごとに1回だけ）
  var sent = {};
  function watchGroups(root) {
    var groups = root.querySelectorAll('[data-c-otomo-group]');
    if (!groups.length) return;

    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var name = entry.target.getAttribute('data-c-otomo-group');
          observer.unobserve(entry.target);
          if (sent[name]) return;
          sent[name] = true;
          push('otomo_group_view', { otomo_group: name });
        });
      },
      { threshold: 0.3 }
    );
    groups.forEach(function (g) {
      observer.observe(g);
    });
  }
  watchGroups(document);

  // 商品画像・商品名のクリック
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-c-otomo-link]');
    if (!link) return;
    var item = link.closest('.c-otomo-item');
    if (!item) return;
    var d = itemData(item);
    push('otomo_product_click', {
      otomo_group: groupName(item),
      item_name: d.item_name,
      item_id: d.item_id,
      link_type: link.getAttribute('data-c-otomo-link'),
    });
  });
})();

/*
 * ご飯のお供ページ：「釜めし屋が、なぜご飯のお供を？」
 * 画面に入ったら、茶碗の線・見出し・本文を順に表示する（[data-c-otomo-reveal] に is-inview を付ける）。
 * html に c-otomo-js を付けたときだけCSSで隠すので、JSが動かない場合は最初から全部表示される。
 */
(function () {
  if (window.cOtomoRevealReady) return;
  window.cOtomoRevealReady = true;

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-inview');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.2 }
        )
      : null;

  function watch(root) {
    root.querySelectorAll('[data-c-otomo-reveal]:not(.is-inview)').forEach(function (el) {
      if (observer) {
        observer.observe(el);
      } else {
        el.classList.add('is-inview');
      }
    });
  }

  document.documentElement.classList.add('c-otomo-js');
  watch(document);

  // テーマエディタでセクションが再読み込みされたとき
  document.addEventListener('shopify:section:load', function (event) {
    watch(event.target);
  });
})();

/*
 * ご飯のお供ページ：「カートに入れる」
 * このテーマのヘッダーにはDawn標準のカート通知が入っていないため、
 * Dawnの product-form を使うとカートページへ移動してしまう。
 * ここではページを移動せずにカートへ追加し、ヘッダーの .cart-count を更新する。
 */
(function () {
  if (window.cOtomoCartReady) return;
  window.cOtomoCartReady = true;

  var routes = window.routes || {};
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var cartUrl = routes.cart_url || '/cart';

  var toast;
  var toastTimer;

  function showToast(message, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'c-otomo-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = '';
    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);

    if (!isError) {
      var link = document.createElement('a');
      link.href = cartUrl;
      link.textContent = 'カートを見る';
      toast.appendChild(link);
    }

    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-show');
    }, 4000);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  // 数量：最小・最大・刻み（数量ルール）の範囲に収める
  function normalizeQty(input) {
    var min = Number(input.min) || 1;
    var step = Number(input.step) || 1;
    var max = input.max ? Number(input.max) : Infinity;
    var value = Math.floor(Number(input.value));

    if (!value || value < min) value = min;
    if (value > max) value = max;
    value = min + Math.round((value - min) / step) * step;
    if (value > max) value -= step;

    input.value = value;

    var wrapper = input.closest('[data-c-otomo-qty]');
    wrapper.querySelector('[data-c-otomo-qty-minus]').disabled = value - step < min;
    wrapper.querySelector('[data-c-otomo-qty-plus]').disabled = value + step > max;
    return value;
  }

  document.querySelectorAll('[data-c-otomo-qty] input').forEach(normalizeQty);

  // テーマエディタでセクションが再読み込みされたとき
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-c-otomo-qty] input').forEach(normalizeQty);
  });

  document.addEventListener('click', function (event) {
    var qtyButton = event.target.closest('[data-c-otomo-qty-minus], [data-c-otomo-qty-plus]');
    if (!qtyButton) return;

    var input = qtyButton.closest('[data-c-otomo-qty]').querySelector('input');
    var step = Number(input.step) || 1;
    var direction = qtyButton.hasAttribute('data-c-otomo-qty-plus') ? 1 : -1;
    input.value = normalizeQty(input) + step * direction;
    normalizeQty(input);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-c-otomo-qty] input')) normalizeQty(event.target);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-c-otomo-add]');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    event.preventDefault();

    var label = button.querySelector('span');
    var defaultText = button.getAttribute('data-default-text') || label.textContent;
    button.setAttribute('data-default-text', defaultText);
    button.classList.add('is-loading');

    var item = button.closest('.c-otomo-item');
    var qtyInput = item ? item.querySelector('[data-c-otomo-qty] input') : null;
    var quantity = qtyInput ? normalizeQty(qtyInput) : 1;

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: quantity }] }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'カートに入れられませんでした');
          }
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } });
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (window.cOtomoTrack) window.cOtomoTrack.addToCart(item, quantity);
        button.classList.add('is-added');
        label.textContent = 'カートに入れました';
        showToast('カートに入れました', false);

        setTimeout(function () {
          button.classList.remove('is-added');
          label.textContent = defaultText;
        }, 2500);
      })
      .catch(function (error) {
        showToast(error.message, true);
      })
      .finally(function () {
        button.classList.remove('is-loading');
      });
  });
})();
